import ActivateButton from '../buttons/activateButton';
import CancelButton from '../buttons/defaultButton';
import Container from '../../atoms/container/modalButtons';
import Focus from '../../../../shared/types/enums/focus';
import List from '../../sections/list/list';
import LoginButton from '../buttons/modalLoginButton';
import Modals from '../../../../shared/types/enums/modals';
import { AnonymousModalButtonsProps as Props } from '../../../../shared/types/props/modal';
import { loginAction } from '../../../../shared/actions/flow';
import {
  popFocus,
  pushFocus,
} from '../../../../shared/store/slices/focus.slice';
import {
  clearModal,
  setModal,
} from '../../../../shared/store/slices/modal.slice';
import { useAppDispatch } from '../../../../shared/store/hooks';
import { useEffect } from 'react';

function AnonymousModalButtons({ allowZapping = false }: Props) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(pushFocus(Focus.MODAL_BUTTONS));
    return () => {
      dispatch(popFocus());
    };
  }, []);

  const activateButtonAction = () => {
    dispatch(setModal(Modals.ACTIVATE_GENERIC));
  };
  const loginButtonAction = () => loginAction();
  const cancelButtonAction = () => dispatch(clearModal());

  return (
    <Container>
      <List focus={Focus.MODAL_BUTTONS}>
        <ActivateButton action={activateButtonAction} index={0} />
        <LoginButton action={loginButtonAction} index={1} />
        {!allowZapping ? (
          <CancelButton releaseAction={cancelButtonAction} index={2} />
        ) : null}
      </List>
    </Container>
  );
}

export default AnonymousModalButtons;
